function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import cn from 'classnames';
import isObjectLike from 'lodash/isObjectLike';
import intlShape from 'shapes/intlShape';
import UniformChoice from './partials/UniformChoice';
var _React_PureComponent;
class InputLikeCheckboxRadio extends (_React_PureComponent = React.PureComponent) {
    renderInfo() {
        if (!this.props.infoMessage) {
            return null;
        }
        return /*#__PURE__*/ _jsx("p", {
            className: "form-info",
            children: isObjectLike(this.props.infoMessage) ? this.props.intl.formatMessage(this.props.infoMessage, _object_spread({}, this.props.infoMessage.values)) : this.props.infoMessage
        });
    }
    render() {
        const id = `${this.props.id}-${this.props.inputValue}`;
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsxs("label", {
                    htmlFor: id,
                    className: cn('form-control', this.props.className, {
                        disabled: this.props.isDisabled
                    }),
                    children: [
                        this.props.renderImage && this.props.renderImage(),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "row h-100 align-items-center",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col",
                                    children: isObjectLike(this.props.labelMessage) ? this.props.intl.formatMessage(this.props.labelMessage, _object_spread({}, this.props.labelMessage.values)) : this.props.labelMessage
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-auto",
                                    children: /*#__PURE__*/ _jsx(UniformChoice, _object_spread_props(_object_spread({}, this.props), {
                                        isMultiple: !this.props.isRadio
                                    }))
                                })
                            ]
                        })
                    ]
                }),
                this.renderInfo()
            ]
        });
    }
}
_define_property(InputLikeCheckboxRadio, "propTypes", {
    // Explicit props
    id: PropTypes.string,
    inputValue: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array
    ]),
    labelMessage: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    infoMessage: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    isRadio: PropTypes.bool,
    isDisabled: PropTypes.bool,
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    renderImage: PropTypes.func,
    // Implicit props
    intl: intlShape.isRequired,
    // Explicit Actions
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func
});
_define_property(InputLikeCheckboxRadio, "defaultProps", {
    id: '',
    value: '',
    isRadio: false,
    isDisabled: false,
    className: ''
});
export default injectIntl(InputLikeCheckboxRadio);
